// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import { sync } from 'vuex-router-sync'
import store from './store'
import JsonExcel from 'vue-json-excel'
import VueQriously from 'vue-qriously'
import { Auth0Plugin, initializeAuth0 } from './auth0-plugin';
import { APIEvent } from './events/apiEvent'
import * as Routes from './constants/routes'
import * as Environments from './constants/environments'
import { EventBus } from './event-bus.js'


Vue.component('DownloadExcel', JsonExcel)

let originalVueComponent = Vue.component
Vue.component = function (name, definition) {
  if (name === 'bFormCheckboxGroup' || name === 'bCheckboxGroup' ||
      name === 'bCheckGroup' || name === 'bFormRadioGroup') {
    definition.components = {bFormCheckbox: definition.components[0]}
  }
  originalVueComponent.apply(this, [name, definition])
}
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueQriously)
Vue.component = originalVueComponent

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  next()
})

sync(store, router)

// Check local storage to handle refreshes
if (window.sessionStorage || window.localStorage) {
  store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  store.commit('SET_ROLEID', window.localStorage.getItem('roleID'))
}

if (!Environments.AUTH0_DOMAIN || !Environments.AUTH0_CLIENT_ID) {
  console.error('Missing required Auth0 configuration. Please check .env file - environment variables');
}

// Install Auth0 plugin
Vue.use(Auth0Plugin)

// Initialize Auth0
initializeAuth0(store, {
  domain: Environments.AUTH0_DOMAIN,
  clientId: Environments.AUTH0_CLIENT_ID,
  redirectUri: Environments.AUTH0_CALLBACK,
  onRedirectCallback: async (appState) => {
    try {
      // Only proceed if we have a valid appState (indicating a real callback)
      if (!appState || typeof appState !== 'object') {
        console.log('No valid appState, skipping token exchange');
        return;
      }
      
      // Exchange the token first - this establishes authentication
      await store.dispatch(APIEvent.EXCHANGE_ID_TOKEN);
      
      // After successful token exchange, use Vue Router for navigation
      const targetPath = appState.targetPath || Routes.HOME;
      
      // 1. Clean query parameters in the base URL
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState(null, '', cleanUrl);
      
      // 2. Use Vue Router to navigate to the target path
      router.replace(targetPath);
      
    } catch (error) {
      
      // Use standardized SSO error message for user feedback
      const errorMessage = 'SSO login failed. Please try again or contact your administrator if the issue persists.';
      
      // Emit error event for immediate component notification
      EventBus.$emit('sso-error', errorMessage);
      
      // Use Vue Router for error navigation with clean URL (only keeping the error parameter)
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState(null, '', cleanUrl);
      router.replace({ path: '/login', query: { error: 'sso_failed' } });
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
